import { render, staticRenderFns } from "./AIBotResponse.vue?vue&type=template&id=731bffb8"
import script from "./AIBotResponse.vue?vue&type=script&lang=js"
export * from "./AIBotResponse.vue?vue&type=script&lang=js"
import style0 from "./AIBotResponse.vue?vue&type=style&index=0&id=731bffb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports